import React from 'react'
import Button from '../../ui-kit/Button'

function UserBlock({ user }) {
  return (
    <div className='UserBlock'>
        <div className="title user_name">
            {user.fullName}
        </div>

        <div className="title user_group">
            {Array.isArray(user.groups) && user.groups.length ? user.groups.map(g => g.name || g).join(', ') : (user.group && user.group.name ? user.group.name : 'нету')}
        </div>

        <div className="title user_pay">
            <Button text="Открыть" />
        </div>

        <div className="title user_rasp">
            <Button text="Открыть" />
        </div>

        <div className="title user_full">
            {/* Здесь больше нет кнопки 'Открыть' */}
        </div>
    </div>
  )
}

export default UserBlock